import './js/btn-up';
import './js/loader';
import './js/movie-api';
import './js/search-field';
import './js/filter';
import './js/create-card';
// import './js/create-card-library';
import './js/modal-film-info';
import './js/modal-trailer';
import './js/pagination';
import './js/pagination-main'
import './js/modal-footer';



// import { MovieAPI } from './js/movie-api';

// var testApi = new MovieAPI();
// testApi.getPopularFilmList().then(filmList => {
//   console.log(filmList);
// });
